import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import config from "../../config";

export const GetExpensesTypes = createAsyncThunk("expensesType/GetExpensesTypes", async ({ token, filters = {} } = {}, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue } = thunkAPI
    try {
        const searchParams = new URLSearchParams();
        Object.entries(filters || {}).forEach(([key, value]) => {
            if (value === undefined || value === null || value === "") return;
            searchParams.append(key, value);
        });
        const query = searchParams.toString();
        const url = `${config.apiUrl}/expense-types${query ? `?${query}` : ""}`;

        if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.debug('[GetExpensesTypes] url=', url);
        }

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            }

        })

        const data = await response.json();
        if (!response.ok) {
            return rejectWithValue(data)
        } else {
            return fulfillWithValue(data)
        }

    } catch (error) {
        throw rejectWithValue(error.message)
    }
})

export const AddExpensesType = createAsyncThunk("expensesType/AddExpensesType", async (obj, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue } = thunkAPI
    try {
        const response = await fetch(`${config.apiUrl}/expense-types`, {
            method: "POST",
            body: JSON.stringify(obj.values),
            headers: {
                'Accept': "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${obj.token}`
            }

        })

        const data = await response.json();
        if (!response.ok) {
            return rejectWithValue(data)
        } else {
            return fulfillWithValue(data)
        }
    } catch (error) {
        throw rejectWithValue(error.message)
    }
})


export const UpdateExpensesType = createAsyncThunk("expensesType/UpdateExpensesType", async (obj, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue } = thunkAPI
    try {
        const response = await fetch(`${config.apiUrl}/expense-types/${obj.id}`, {
            method: "PUT",
            body: JSON.stringify(obj.values),
            headers: {
                'Accept': "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${obj.token}`
            }

        })

        const data = await response.json();
        if (!response.ok) {
            return rejectWithValue(data)
        } else {
            return fulfillWithValue(data)
        }


    } catch (error) {
        throw rejectWithValue(error.message)
    }
})


export const DeleteExpensesType = createAsyncThunk("expensesType/DeleteExpensesType", async (obj, thunkAPI) => {
    const { rejectWithValue, fulfillWithValue } = thunkAPI
    try {
        const response = await fetch(`${config.apiUrl}/expense-types/${obj.id}`, {
            method: "DELETE",
            headers: {
                'Accept': "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${obj.token}`
            }

        })

        const data = await response.json();
        if (!response.ok) {
            return rejectWithValue(data)
        } else {
            return fulfillWithValue(data)
        }


    } catch (error) {
        throw rejectWithValue(error.message)
    }
})

export const ExpensesTypeSlice = createSlice({
    name: "expensesType",
    initialState: {
        expensesType: null,
        error: null,
        loading: false,
        successMessage: null,
        selectedType: null
    },

    reducers: {
        selectType: (state, action) => {
            state.selectedType = action.payload
        }
    },

    extraReducers: {
        [GetExpensesTypes.pending]: (state, action) => {
            state.loading = true
           state.successMessage = null
           state.error = null
        },
        [GetExpensesTypes.fulfilled]: (state, action) => {
            state.loading = false
            state.expensesType = action.payload.data
            state.successMessage = null
           state.error = null
        },
        [GetExpensesTypes.rejected]: (state, action) => {
            state.loading = false
            state.successMessage = null
            state.error = null
        },

        [AddExpensesType.pending]: (state, action) => {
            state.loading = true
            state.successMessage = null
           state.error = null
        },
        [AddExpensesType.fulfilled]: (state, action) => {
            state.loading = false
            state.expensesType = [...state.expensesType, action.payload?.data]
            state.successMessage = action.payload.data.message
            state.successMessage = action.payload.message
           state.error = null

        },
        [AddExpensesType.rejected]: (state, action) => {

            state.loading = false
            state.successMessage = null
           state.error = action.payload.message
            
        },
        [UpdateExpensesType.pending]: (state, action) => {
            state.loading = true
            state.successMessage = null
           state.error = null
        },
        [UpdateExpensesType.fulfilled]: (state, action) => { 
            state.loading = false
            const index = state.expensesType.findIndex(type => type.id === action.payload.data.id);
            state.expensesType[index] = {
                ...state.expensesType[index],
                ...action.payload.data,
            };
            state.successMessage = action.payload.message
           state.error = null

        },
        [UpdateExpensesType.rejected]: (state, action) => {

            state.loading = false
            state.successMessage = null
           state.error = action.payload.message
            
        },

        [DeleteExpensesType.pending]: (state, action) => {
            state.loading = true
            state.successMessage = null
           state.error = null
        },
        [DeleteExpensesType.fulfilled]: (state, action) => {
            state.loading = false
            let index = state.expensesType.findIndex(({ id }) => id === action.payload.data?.id);
            state.expensesType.splice(index, 1);
            state.successMessage = action.payload.message
           state.error = null

        },
        [DeleteExpensesType.rejected]: (state, action) => {

            state.loading = false
            state.successMessage = null
           state.error = action.payload.message
            
        },
    }
})

export default ExpensesTypeSlice.reducer;
export const { selectType } = ExpensesTypeSlice.actions